import { z } from "zod";

export const selectDocumentsSchema = z.object({
  selectedDocuments: z.array(z.object({ id: z.string() })),
});

export type SelectDocumentsForm = z.infer<typeof selectDocumentsSchema>;
